export default __webpack_public_path__ + "static/media/scratch10.cbabe55e.mp3";